import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { EnvironmentService } from '../@core/services/environment.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private headers = new HttpHeaders();
  private API_BASE_URL: string;

  constructor(
    private http: HttpClient,
    private readonly environmentService: EnvironmentService,
  ) {
    this.API_BASE_URL = this.environmentService.trappEndpointRootApi + '/client/keyset';
    this.headers = this.headers.set('x-api-key', this.environmentService.trappApiKey);
  }

  getTranslation(lang: string): Observable<any> {
    return this.http
      .get(`${this.API_BASE_URL}/${lang}`, { params: { format: 'OBJECT', useFallback: 'true' }, headers: this.headers })
      .pipe(
        map((response: any) => response.keySet),
      )
      .pipe(
        catchError((error) => {
          console.warn(`Failed to load translations from API for ${lang}:`, error);
          // Fallback to local translations
          return this.getLocalTranslation(lang);
        }),
      );
  }

  private getLocalTranslation(lang: string): Observable<any> {
    // Load local translation files as fallback
    return this.http.get(`./assets/i18n/${lang}.json`).pipe(
      catchError((error) => {
        console.error(`Failed to load local translations for ${lang}:`, error);
        // Return empty object if both HTTP and local fail
        return of({});
      }),
    );
  }
}
